import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetHistoryTemplateDetail = (params: any) =>
    GET_ENC(`${BASE_URL}/api/HistoryTemplate/GetDetail?` + params, null);

export const GetHistoryTemplateList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/HistoryTemplate/GetList?` + params, null);

export const CreateHistoryTemplate = (data: any) =>
    POST_ENC(`${BASE_URL}/api/HistoryTemplate/Create`, data);

export const UpdateHistoryTemplate = (data: any) =>
    POST_ENC(`${BASE_URL}/api/HistoryTemplate/Update`, data);

export const DeleteHistoryTemplate = (data: any) =>
    POST_ENC(`${BASE_URL}/api/HistoryTemplate/Delete`, data);

export const RenameHistoryTemplate = (data: any) =>
    POST_ENC(`${BASE_URL}/api/HistoryTemplate/Rename`, data);

export const SaveAsHistoryTemplate = (data: any) =>
    POST_ENC(`${BASE_URL}/api/HistoryTemplate/SaveAs`, data);

export const SaveHistoryTemplateByHistory = (data: any) =>
    POST_ENC(`${BASE_URL}/api/HistoryTemplate/SaveByHistory`, data);